import type { Pinia } from 'pinia'
import { defineNuxtPlugin } from '#app'

import { persistedStatePlugin } from '@packages/persiststate/pinia-plugin.ts'

export default defineNuxtPlugin((nuxtApp) => {
  const pinia = nuxtApp.$pinia as Pinia

  pinia.use(persistedStatePlugin)
})
